(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  // Aleluya: vendor page — full-price first (newest→oldest), then on-sale (newest→oldest)
  (function() {
    if (!window.location.pathname.includes('/collections/vendors') ||
        !window.location.search.includes('sort_by=created-descending')) return;

    var container = null;
    var observer = null;

    function reorder() {
      if (!container) return;
      if (observer) observer.disconnect();

      var items = Array.from(container.children).filter(function(el) {
        return el.classList && el.classList.contains('product__grid-item');
      });
      if (items.length >= 2) {
        var full = [], sale = [];
        items.forEach(function(el) {
          (el.querySelector('.product-thumbnail__price.sale') ? sale : full).push(el);
        });
        full.concat(sale).forEach(function(el) { container.appendChild(el); });
      }

      if (observer) observer.observe(container, { childList: true });
    }

    function init() {
      var first = document.querySelector('.product__grid-item');
      if (!first) return;
      container = first.parentNode;
      observer = new MutationObserver(function(muts) {
        var hasNew = muts.some(function(m) {
          return Array.from(m.addedNodes).some(function(n) {
            return n.nodeType === 1 && n.classList && n.classList.contains('product__grid-item');
          });
        });
        if (hasNew) reorder();
      });
      reorder();
    }

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init)
      : init();
  })();

  } catch(e) { console.error(e); }
})();
})();
